const { Core, Events } = Global;
const EVENT_SRC = "filter";

customElements.define(
  "collection-filter-list",
  class extends Core {
    propTypes = { "form-id": String };

    render() {
      this.$({ change: this._changeHandler });
      this.sub(Events.COLLECTION_UPDATED, this._handleCollectionUpdate);
    }

    _changeHandler(e) {
      this.pub(Events.COLLECTION_CHANGE, {
        src: EVENT_SRC,
        formId: this.prop("form-id"),
      });
    }

    _handleCollectionUpdate({ doc, src }) {
      if (src !== EVENT_SRC) return;

      this.updateContentFrom(doc);

      // Fix: when a filter is removed via the "Filtered by:" chip instead of
      // this form, these checkboxes were never directly clicked, so their
      // live `.checked` never flips even after updateContentFrom patches the
      // node's attributes. Force-sync `.checked` from the new doc explicitly.
      doc.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((newInput) => {
        if (!newInput.id) return;
        const current = this.querySelector(`#${CSS.escape(newInput.id)}`);
        if (current) current.checked = newInput.checked;
      });
    }
  }
);